import {Box} from '@mui/material';

export default function HomePartnerOfficeScreen() {
  return <Box>🔨 In progress...</Box>;
}
